import React from 'react';
import { Trans } from '@wix/yoshi-flow-editor';
import { RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY } from '@wix/communities-blog-client-common';
import { type MessageDescriptor } from './message';
import { TECHNICAL_ISSUE_ERROR } from './message-types';

const Content = ({ i18nKey }: { i18nKey: string }) => (
  <span>
    <Trans i18nKey={i18nKey} />
  </span>
);

const messageMapByType: Record<string, MessageDescriptor> = {
  [RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY]: {
    content: () => <Content i18nKey="messages.download-will-begin-shortly" />,
    type: 'info',
  },
  [TECHNICAL_ISSUE_ERROR]: {
    content: () => <Content i18nKey="messages.technical-issue" />,
    type: 'error',
  },
};

export default messageMapByType;
